import script from "./PromotionLimiteeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionLimiteeView.vue?vue&type=script&setup=true&lang=ts"

import "./PromotionLimiteeView.vue?vue&type=style&index=0&id=7004297d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7004297d"]])

export default __exports__